import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../../../../../../store/root-reducer';
import { getCountriesOptionsForNumbersSearchRequest, getPhoneNumbersCartRequest, searchPhoneNumbersRequest } from '../../../../../../../../extra-actions';
import { resetPurchasePhoneNumbersCartRequest, setIsRegionChangedInLastSearch, setLastSearchRegion } from '../../../../../../../../dialer-slice';
import { SearchPhoneNumbersPayload } from '../../../../../../../../types/phone-numbers';
import SearchNumbers from './search-numbers';

export interface SearchNumbersProps {}

const SearchNumbersContainer = memo(() => {
  const dispatch = useDispatch();
  
  const countriesOptionsForNumbersSearch = useSelector(
    (state: RootState) => state.dialer.countriesOptionsForNumbersSearch,
  );

  const searchPhoneNumbersRequestStatus = useSelector(
    (state: RootState) => state.dialer.searchPhoneNumbersRequest.status,
  );
  const purchasePhoneNumbersCartRequestState = useSelector(
    (state: RootState) => state.dialer.purchasePhoneNumbersCartRequest,
  );

  const getCountriesOptionsForNumbersSearchRequestAction = useCallback(() => {
    dispatch(getCountriesOptionsForNumbersSearchRequest());
  }, [dispatch]);

  const searchPhoneNumbersRequestAction = useCallback((payload: SearchPhoneNumbersPayload) => {
    dispatch(searchPhoneNumbersRequest(payload));
  }, [dispatch]);

  const setIsRegionChangedInLastSearchAction = useCallback((value: boolean) => {
    dispatch(setIsRegionChangedInLastSearch(value));
  }, [dispatch]);

  const setLastSearchRegionAction = useCallback((region: string | null) => {
    dispatch(setLastSearchRegion(region));
  }, [dispatch]);

  const handleResetPurchasePhoneNumbersCartRequest = useCallback(() => {
    dispatch(resetPurchasePhoneNumbersCartRequest());
  }, [dispatch]);

  const handleGetPhoneNumbersCartRequest = useCallback(() => {
    dispatch(getPhoneNumbersCartRequest());
  }, [dispatch]);

  return (
    <SearchNumbers
      getCountriesOptionsForNumbersSearchRequest={getCountriesOptionsForNumbersSearchRequestAction}
      countriesOptionsForNumbersSearch={countriesOptionsForNumbersSearch}
      searchPhoneNumbersRequest={searchPhoneNumbersRequestAction}
      searchPhoneNumbersRequestStatus={searchPhoneNumbersRequestStatus}
      setIsRegionChangedInLastSearch={setIsRegionChangedInLastSearchAction}
      setLastSearchRegion={setLastSearchRegionAction}
      resetPurchasePhoneNumbersCartRequest={handleResetPurchasePhoneNumbersCartRequest}
      purchasePhoneNumbersCartRequestState={purchasePhoneNumbersCartRequestState}
      getPhoneNumbersCartRequest={handleGetPhoneNumbersCartRequest}
    />
  );
});

SearchNumbersContainer.displayName = 'SearchNumbersContainer';

export default SearchNumbersContainer;

